import React, { Fragment } from 'react';
import _ from 'lodash';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const STICKY_MFR_WIDTH = 168

const styles = theme => ({
	root: {
		width: '100%',
		overflowX: 'auto',
	},
	tableRow: {
		height: 'auto',
	},
	row: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.background.default,
		},
	},
	stickyHeadMfr: {
		position: 'sticky',
		left: 0,
		top: 0,
		zIndex: 12,
		minWidth: STICKY_MFR_WIDTH,
		maxWidth: 220,
		backgroundColor: theme.palette.grey[50],
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.2)',
	},
	stickyHeadModel: {
		position: 'sticky',
		left: STICKY_MFR_WIDTH,
		top: 0,
		zIndex: 11,
		minWidth: 240,
		backgroundColor: theme.palette.grey[50],
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.15)',
	},
	stickyHeadModelOnly: {
		position: 'sticky',
		left: 0,
		top: 0,
		zIndex: 12,
		minWidth: 260,
		backgroundColor: theme.palette.grey[50],
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.2)',
	},
	subCaption: {
		fontWeight: 400,
		color: 'rgba(0, 0, 0, 0.62)',
		marginTop: 4,
		fontSize: '0.75rem',
		lineHeight: 1.3,
	},
	headRowSep: {
		borderBottom: `2px solid ${theme.palette.grey[300]}`,
	},
});
const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.grey[50],
        color: theme.palette.grey[900],
        border: "none",
        fontFamily: 'NHaasGroteskDSPro-65Md',
        fontSize: 14,
        verticalAlign: "top",
        paddingTop: theme.spacing(2),
        paddingBottom:0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        height: "auto",
        whiteSpace: 'nowrap',
    },
 
}))(TableCell);
const SubTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.grey[50],
        color: theme.palette.grey[700],
        border: "none",
        fontFamily: 'NHaasGroteskDSPro-55Rg',
        fontSize: 13,
        verticalAlign: "top",
        paddingTop: 0,
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        height: "auto",
        whiteSpace: 'nowrap',
    },

}))(TableCell);

class ProductHeaderRow extends React.Component {


    constructor(props) {
        super(props);
        this._id = _.uniqueId('product_header_row');

    }
    shouldComponentUpdate(nextProps) {
        return (
            this.props.adminView !== nextProps.adminView
            || this.props.showManufacturer !== nextProps.showManufacturer
            || this.props.hideSerialsDivider !== nextProps.hideSerialsDivider
            || this.props.showWarranty !== nextProps.showWarranty
        );
    }
    render() {
        const {
			classes,
			adminView,
			showManufacturer,
			hideSerialsDivider,
			showWarranty = true,
		} = this.props;
        const serialsSpan = hideSerialsDivider ? 1 : 2;

        return (
            <Fragment>
                <TableRow key={this._id} className={classes.tableRow}>
                    {showManufacturer && (
                        <CustomTableCell rowSpan={2} className={classes.stickyHeadMfr}>
							Manufacturer
						</CustomTableCell>
                    )}
                    <CustomTableCell
						rowSpan={2}
						className={showManufacturer ? classes.stickyHeadModel : classes.stickyHeadModelOnly}
					>
                        Model name
                        <Typography variant="caption" display="block" className={classes.subCaption}>
                            Power · Storage
                        </Typography>
                    </CustomTableCell>
                    <CustomTableCell rowSpan={2}>
                        Type
                        <Typography variant="caption" display="block" className={classes.subCaption}>
                            Hover summary for full component / listing text
                        </Typography>
                    </CustomTableCell>
                    <CustomTableCell rowSpan={2}>Product line</CustomTableCell>
                    <CustomTableCell rowSpan={2}>
						Dates
						<Typography variant="caption" display="block" className={classes.subCaption}>
							Approved · Expires
						</Typography>
					</CustomTableCell>
                    {showWarranty ? (
						<CustomTableCell colSpan={2}>Warranty (in yrs)</CustomTableCell>
					) : null}
                    <CustomTableCell colSpan={serialsSpan} align="left">&nbsp;</CustomTableCell>
                    <CustomTableCell>Serials not found on service</CustomTableCell>
                    {adminView ? null : (<CustomTableCell>&nbsp;</CustomTableCell>)}
                </TableRow>
                <TableRow className={`${classes.tableRow} ${classes.headRowSep}`}>
                    {showWarranty ? (
						<Fragment>
							<SubTableCell>Component</SubTableCell>
							<SubTableCell>Performance</SubTableCell>
						</Fragment>
					) : null}
                    <SubTableCell>Available vs Total Serials</SubTableCell>
                    {hideSerialsDivider ? null : (<SubTableCell>&nbsp;</SubTableCell>)}
                    <SubTableCell>Failed vs Total Requests</SubTableCell>
                    {adminView ? null : (<SubTableCell>&nbsp;</SubTableCell>)} 
                </TableRow>
                    {/* <tr key={this._id}>
                    <th rowSpan="2">Model</th>
                    <th rowSpan="2">Product line</th>
                    <th colSpan="2">Dates</th>
                    <th colSpan="2">Warranty (in yrs)</th>
                    <th className="verserout">Serials available for verification</th>
                    <th>&nbsp;</th>
                    <th >Serials not found on service</th>
                    <th>&nbsp;</th>
                </tr>
                <tr className="subhead">
                    <th>Approval date</th>
                    <th>Expiry date</th>
                    <th>Component</th>
                    <th>Performance</th>

                    <th className="verserout">Avaiable vs Total Serials</th>
                    <th>&nbsp;</th>
                    <th>Failed vs Total Requests</th>
                    <th>&nbsp;</th>
                </tr> */}
            </Fragment>
        );




    }
}

ProductHeaderRow.defaultProps = {
	showWarranty: true,
};

export default withStyles(styles)(ProductHeaderRow);
